import styled from "styled-components";

export const SafetyWrapper = styled.div`
  padding: 1rem;
  border-radius: 1.2rem;
  background-color: #ffffff;
  margin: 0 0 1.7rem 0};
`;
export const SafetyHeader = styled.div(
  (props) => `
    display: flex;
    align-items: center;
    margin-bottom: 1.5rem;
    h4{
        font-family: 'Rubik';
        font-size: 1.4rem;
        margin-bottom: 0.2rem;
        font-weight: 600;
        color: #151823;
    }
    p{
        font-family: ${props.theme.font.fontFamily};
        font-size: 1.2rem;
        line-height: 1.6rem;
        color: #647a97;
    }
`
);
export const SafetyTag = styled.div`
  width: 7.2rem;
  height: 3.2rem;
  border-radius: 0.4rem;
  background-color: #e9f6ea;
  flex-shrink: 0;
  padding: 0 1rem;
  margin-right: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const SafetyList = styled.ul`
  display: flex;
  > li {
    width: 8.6rem;
    height: 11.4rem;
    overflow: hidden;
    border-radius: 0.4rem;
    margin-right: 0.8rem;
    flex-shrink: 0;
  }
`;
export const SafetyListItem = styled.ul`
  width: 8.6rem;
  height: 11.4rem;
  overflow: hidden;
  border-radius: 0.4rem;
  margin-right: 0.8rem;
  flex-shrink: 0;
  background: url(${(props) => props.bgImage}) 0 0 no-repeat;
  background-size: cover;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  .itemTop {
    display: flex;
    align-items: center;
    padding: 0.3rem;
  }
  .driverIcon {
    width: 2.5rem;
    height: 2.5rem;
    border: solid 0.1rem #ffffff;
    border-radius: 50%;
    margin-right: 0.5rem;
    flex-shrink: 0;
    object-fit: cover;
    // background: url(${(props) => props.userImage});
  }
  .driverName {
    font-family: 'Rubik';
    font-size: 1.1rem;
    color: #fff;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .foot {
    height: 3rem;
    border-radius: 0 0 0.4rem 0.4rem;
    background-color: rgba(0, 0, 0, 0.48);
    display: flex;
    align-items: center;
    padding: 0 0.5rem;
    font-family: 'Rubik';
    font-size: 1.1rem;
    line-height: 1.3rem;
    font-weight: 600;
    color: #fff;
    margin-top: auto;
  }
`;

export const SliderArrow = styled.button(
  props => `
      width: 4rem;
      height: 4rem;
      display: flex;
      border-radius: 50%;
      background-color: white;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: absolute;
      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);
      border:none;
      outline: 0;
      &.right {
        top: 92px;
        right: -1rem;
        transform: translateY(-50%);
      }
      &.left {
        top: 92px;
        left: -1rem;
        transform: translateY(-50%);
      }
    `,
);

export const SubTitle = styled.span(
  props => `
  font-family: 'Rubik';
  font-size: 1.2rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #647a97;
  padding-right: 1rem;
  `
);
